import { useEffect, useState, type DragEvent, type ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Dosya bırakma alanı (HTML5, #292). Yalnız ilk dosya alınır; .xlsx değilse kullanıcıya söylenir. */
/** `fileName`: dosya başka yoldan (Dosya seç) değişince bırakma hatası silinir. */
export function DropZone({ onFile, fileName, className, children }: { onFile: (f: File) => void; fileName?: string | null; className?: string; children: ReactNode }) {
  const [over, setOver] = useState(false);
  const [bad, setBad] = useState("");
  useEffect(() => setBad(""), [fileName]);
  const drop = (e: DragEvent) => {
    e.preventDefault(); setOver(false);
    const f = e.dataTransfer.files[0];
    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".xlsx")) { setBad(`"${f.name}" yüklenemez: yalnız .xlsx dosyası kabul edilir.`); return; }
    setBad(""); onFile(f);
  };
  return (
    <div
      data-over={over || undefined} className={cn("rounded-lg transition-colors data-[over]:bg-primary/5 data-[over]:ring-2 data-[over]:ring-primary", className)}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={(e) => { if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setOver(false); }}
      onDrop={drop}
    >
      {children}
      {bad && <p role="alert" className="mt-2 text-sm text-destructive">{bad}</p>}
    </div>
  );
}
